<template>
  <div class="modal fade" id="upload-evidence-image-modal" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-md" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="flexbox">
            <div class="col-sm-12">
              <evidence-image-input
                :option="this.option"
                @close="$emit('close')"
                @handleSuccess="$emit('handleSuccess')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EvidenceImageInput from '@/components/EvidenceImageInput'
export default {
  components: {
    EvidenceImageInput
  },
  computed: {
    option () {
      return {
        url: `${process.env.NODE_SERVER_API}EvidenceImage/upload`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
        thumbnailWidth: 300,
        maxFilesize: 1024,
        maxFiles: 1,
        acceptedFiles: 'image/jpg, image/jpeg, image/gif, image/png, image/bmp',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: '審査に必要なファイルを、ここにドラッグ＆ドロップ<br><br><button class="btn btn-info w-200">またはファイルを選択</button>',
        dictInvalidFileType: 'この形式のファイルはアップロードできません。',
        dictMaxFilesExceeded: '複数のファイルをアップロードすることはできません。'
      }
    }
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
#upload-evidence-image-modal {
  z-index: 1049;
}
#upload-evidence-image-modal /deep/ .dz-error-message {
  top: 40%;
  padding: 0.2rem 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/UploadEvidenceImageModal.vue